import { Skeleton } from "components/ui/skeleton";

export function IntegrationActiveCardSkeleton() {
  return (
    <div className="relative overflow-hidden dark:bg-dark-800 p-5 rounded-xl shadow-sm border border-line-subtle dark:border-dark-700 fade-in">
      {/* Accent top bar placeholder */}
      <div className="absolute top-0 inset-x-0 h-[2px] loading-shimmer dark:loading-shimmer rounded-none" />

      {/* Header: logo + name + status chip */}
      <div className="flex items-start justify-between mb-4 pt-1">
        <div className="flex items-center gap-3">
          {/* Logo box */}
          <Skeleton className="w-9 h-9 rounded-lg flex-shrink-0" />
          <div className="space-y-1.5">
            <Skeleton variant="text" className="!w-32" />
            <Skeleton variant="text" className="!w-20" />
          </div>
        </div>
        {/* Status badge */}
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>

      {/* Capabilities label */}
      <Skeleton variant="text" className="!w-24 mb-2" />
      {/* Capability tags */}
      <div className="flex flex-wrap gap-1.5">
        <Skeleton className="h-5 w-14 rounded-md" />
        <Skeleton className="h-5 w-16 rounded-md" />
        <Skeleton className="h-5 w-20 rounded-md" />
      </div>
    </div>
  );
}

export function IntegrationAvailableCardSkeleton() {
  return (
    <div className="relative overflow-hidden dark:bg-dark-800 p-5 rounded-xl shadow-sm border border-line-subtle dark:border-dark-700 flex flex-col fade-in">
      {/* Accent top bar placeholder */}
      <div className="absolute top-0 inset-x-0 h-[2px] loading-shimmer dark:loading-shimmer rounded-none" />

      {/* Header: logo + name + status */}
      <div className="flex items-start justify-between mb-4 pt-1">
        <div className="flex items-center gap-3">
          {/* Logo box */}
          <Skeleton className="w-9 h-9 rounded-lg flex-shrink-0" />
          <div className="space-y-1.5">
            <Skeleton variant="text" className="!w-28" />
            <Skeleton variant="text" className="!w-20" />
          </div>
        </div>
        {/* Status pill */}
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>

      {/* Capabilities */}
      <div className="mb-4 flex-1">
        <Skeleton variant="text" className="!w-24 mb-2" />
        <div className="flex flex-wrap gap-1.5">
          <Skeleton className="h-5 w-14 rounded-md" />
          <Skeleton className="h-5 w-18 rounded-md" />
          <Skeleton className="h-5 w-16 rounded-md" />
        </div>
      </div>

      {/* Connect button */}
      <Skeleton className="h-9 w-full rounded-xl" />
    </div>
  );
}